
export const statusToPercent = {
  analysising: 3,
  analizing: 10,
  generating: 97,
  encrypt: 98,
  storage_upload: 99,
  ready: 100,
};

export const keysStatuses = Object.keys(statusToPercent); 

export const simulateProgress = (
  status: string,
  setPercent: (value: number) => void,
  intervalId: NodeJS.Timer | null,
  currentPercent: number,
): (() => void) => {
  const maxPercent = statusToPercent[status as keyof typeof statusToPercent];    
  if (intervalId) clearInterval(intervalId);

  intervalId = setInterval(() => {
      
    let prevStatusMax = 0
    const indexPrev = keysStatuses.findIndex((el: any) => el === status) - 1;
    if (indexPrev >= 0) {
      prevStatusMax = statusToPercent[keysStatuses[indexPrev] as keyof typeof statusToPercent]
    }
    const step = 0.5;
    currentPercent = Math.min(currentPercent + step, maxPercent || 1);
    if (prevStatusMax > currentPercent) {
      currentPercent = prevStatusMax;
      setPercent(prevStatusMax);
    } else {
      setPercent(Math.floor(currentPercent));
    }

    if (currentPercent >= maxPercent) {
      clearInterval(intervalId!);
      intervalId = null;
    }
  }, 500);

  return () => {
    if (intervalId) clearInterval(intervalId);
    intervalId = null;
  };
};
